/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupstatewaitlist2Inputs */

const en_signupstatewaitlist2 = /** @type {(inputs: Signupstatewaitlist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting list`)
};

const de_signupstatewaitlist2 = /** @type {(inputs: Signupstatewaitlist2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteliste`)
};

/**
* | output |
* | --- |
* | "Waiting list" |
*
* @param {Signupstatewaitlist2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupstatewaitlist2 = /** @type {((inputs?: Signupstatewaitlist2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupstatewaitlist2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupstatewaitlist2(inputs)
	return de_signupstatewaitlist2(inputs)
});
export { signupstatewaitlist2 as "signupStateWaitlist" }